import { useLang } from "@/context/LanguageContext";

export const ExpertiseMarquee = () => {
  const { t } = useLang();
  const items = [...t.marquee, ...t.marquee, ...t.marquee, ...t.marquee];

  return (
    <div className="bg-pastel-blue border-y border-ser-blue/15 py-4 overflow-hidden" data-testid="expertise-marquee" aria-label={t.marquee.join(" · ")}>
      <div className="flex w-max animate-marquee">
        {[0, 1].map((copy) => (
          <div key={copy} className="flex shrink-0" aria-hidden={copy === 1}>
            {items.map((item, i) => (
              <span key={`${copy}-${i}`} className="flex items-center text-xs md:text-sm uppercase tracking-[0.25em] text-navy/60 font-medium whitespace-nowrap">
                <span className="px-6">{item}</span>
                <span className="w-1.5 h-1.5 rounded-full bg-ser-purple/50" aria-hidden="true" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
